/* eslint-disable max-len */
import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Formik, Form, Field } from 'formik';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import gql from 'graphql-tag';
import { useHistory } from 'react-router-dom';
import { LegacyInputTextComponent } from '../components/prime-formik';
import apollo from '../services/apollo';

const SEND_RESET_PASSWORD_EMAIL = gql`
  mutation($email: String!) {
    sendResetPasswordEmail(email: $email)
  }
`;

const sendResetPasswordEmail = email => apollo
  .mutate({
    mutation: SEND_RESET_PASSWORD_EMAIL,
    variables: {
      email,
    },
  })
  .then(res => res.data);

const i18n = defineMessages({
  emailRequired: { id: 'register.email_required', defaultMessage: 'Email is required' },
});

const ForgotPassword = () => {
  const history = useHistory();
  const { formatMessage } = useIntl();

  const forgotPassword = async (values, resetForm) => {
    const {
      email,
    } = values;

    try {
      await sendResetPasswordEmail(email).then(() => {
        resetForm();
      });
    } catch (error) {
      resetForm();
    }
  };


  const initialValues = {
    email: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required(formatMessage(i18n.emailRequired)),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        const { resetForm } = formikBag;
        forgotPassword(values, resetForm);
      }}
      render={({ handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <div className="p-grid p-fluid p-justify-center logo-top">
            <img src="images/default-195.png" className="brand center-block" alt="GPI Logo" />
          </div>
          <div className="p-grid p-fluid p-justify-center">
            <div className="p-col-12 p-md-3">
              <FormattedMessage id="forgot_password.instructions" defaultMessage="Enter your email address and we'll send you an email to reset your password">
                {text => (
                  <h4 className="center-aligned-instructions">{text}</h4>
                )}
              </FormattedMessage>
            </div>
          </div>
          <div className="p-grid p-fluid p-justify-center">
            <div className="p-col-12 p-md-3">
              <FormattedMessage id="register.email" defaultMessage="Email">
                {text => <Field id="email" name="email" component={LegacyInputTextComponent} placeholder={text} />}
              </FormattedMessage>
            </div>
          </div>
          <br />
          <div className="p-grid p-fluid p-justify-center">
            <div className="p-col-6 p-md-1">
              <FormattedMessage id="forgot_password.submit" defaultMessage="Send email">
                {text => (
                  <Button
                    type="submit"
                    label={text}
                    disabled={isSubmitting}
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="p-col-6 p-md-1">
              <FormattedMessage id="forgot_password.cancel" defaultMessage="Cancel">
                {text => (
                  <Button
                    type="button"
                    label={text}
                    className="p-button-secondary"
                    onClick={() => history.push('/')}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

export default ForgotPassword;
